import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

export function ConfirmDeleteModal({ open, onClose, onConfirm, title, message }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[100] p-4" onClick={onClose}>
      <div className="bg-zinc-900 border border-red-800/50 rounded-2xl w-full max-w-sm shadow-2xl" onClick={e => e.stopPropagation()}>
        <div className="p-5 text-center">
          <div className="w-12 h-12 rounded-full bg-red-900/40 border border-red-700 flex items-center justify-center mx-auto mb-3">
            <AlertTriangle size={22} className="text-red-400" />
          </div>
          <h3 className="text-zinc-50 font-semibold text-sm">{title || 'Confirm Delete'}</h3>
          <p className="text-zinc-400 text-xs mt-2 leading-relaxed">{message || 'This action cannot be undone. All linked data will be removed.'}</p>
        </div>
        <div className="flex border-t border-zinc-800">
          <button onClick={onClose} data-testid="cancel-delete-btn"
            className="flex-1 py-3 text-zinc-400 text-sm font-medium hover:bg-zinc-800 transition-colors rounded-bl-2xl">
            Cancel
          </button>
          <button onClick={onConfirm} data-testid="confirm-delete-btn"
            className="flex-1 py-3 text-red-400 text-sm font-semibold hover:bg-red-900/30 transition-colors border-l border-zinc-800 rounded-br-2xl">
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
}
